module.exports = __webpack_public_path__ + "ao.no2.587bf6be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ao.no2.jpg
// module id = lviG
// module chunks = 0